/// <amd-module name="TFS/Mobile/Components/MobileBanner" />
import * as React from "react";

import * as MobileResources from "TFS/Mobile/Resources";
import { IVssLayoutManager, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { routeUrl } from "VSS/Platform/Location";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { deleteCookie } from "VSS/Platform/Util/Cookie";

interface IMobileBannerComponentProps {
    /**
     * Message to display on the banner.
     */
    message?: string;

    /**
     * Route id of the URL to redirect to if different from the current page/URL.
     */
    mobileRouteId?: string;
}

class MobileBannerComponent extends VssComponent<IMobileBannerComponentProps, {}> {
    public static componentType = "mobileBanner";

    public render(): JSX.Element {
        const message = this.props.message || MobileResources.MobileBannerMessage;
        return (
            <div className="mobile-banner flex flex-noshrink flex-center justify-center">
                <button className="mobile-banner-button" onClick={this._onClick}>
                    <span className="bowtie-icon bowtie-cellphone" />
                    <span className="text">{message}</span>
                </button>
            </div>
        );
    }

    private _onClick = () => {
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("MobileNavigation", "SwitchToMobile", {});

        deleteCookie("VstsBypassMobile");

        if (this.props.mobileRouteId) {
            window.location.href = routeUrl(this.context.pageContext, this.props.mobileRouteId);
        } else {
            // @ts-ignore TypeScript 4.4 upgrade
            window.location.reload(true);
        }
    };
}

VssComponent.register(MobileBannerComponent.componentType, MobileBannerComponent);
